'use client';

import Link from "next/link";
import { usePathname } from "next/navigation";

type IProps = {
  children: any,
  href: string,
  className?: string,
  fullMatch?: boolean,
}

export default function ActiveLink({ children, href, className = '', fullMatch = true }: IProps) {
  const pathname = usePathname();
  const isActive = fullMatch ? pathname === href : pathname.startsWith(href);

  return (
    <Link className={ `${className} ${isActive && 'active'}` } href={href}>
      {children}
    </Link>
  )
}
